import { ValidatorFn } from '@angular/forms';

// TODO(tbottonari): implement validator.
export function listValidator(): ValidatorFn {
    return null;
}
